import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PropTypes from 'prop-types';

import {
  Container,
  Card,
  Text,
  Link,
  CustomSlider,
  Wrapper,
  TimelineDot,
  VerticalLine,
  LinkHighlight,
} from './styles';

import PDFSlide from '../../../static/docs/criterios_precatorios.pdf';

function ResponsiveTimeline({ timeline }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots',
    arrows: false,
  };

  return (
    <Container>
      <CustomSlider {...settings}>
        <Wrapper>
          <TimelineDot>{1}</TimelineDot>
          <Card>
            <Link
              href={PDFSlide}
              download="criterios_precatorios.pdf"
              title="Clique para saber mais sobre os critérios de compra."
            >
              O primeiro passo é se informar sobre nossos critérios de
              elegibilidade, você pode consultá-los{' '}
              <LinkHighlight>aqui</LinkHighlight>.
            </Link>
          </Card>
          <VerticalLine />
        </Wrapper>
        {timeline.map((item, index) => {
          return (
            <Wrapper key={item.title}>
              <TimelineDot>{index + 2}</TimelineDot>
              <Card>
                <Text>{item.title}</Text>
              </Card>
              <VerticalLine />
            </Wrapper>
          );
        })}
      </CustomSlider>
    </Container>
  );
}
ResponsiveTimeline.propTypes = {
  timeline: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ResponsiveTimeline;
